import aps from './aps.json';
import defence from './defence.json';
import ato from './ato.json';
import abs from './abs.json';
import servicesAustralia from './services-australia.json';
import homeAffairs from './home-affairs.json';
import dfat from './dfat.json';
import treasury from './treasury.json';
import finance from './finance.json';
import health from './health.json';
import education from './education.json';
import ags from './ags.json';
import agriculture from './agriculture.json';
import infrastructure from './infrastructure.json';
import industry from './industry.json';
import veteransAffairs from './veterans-affairs.json';
import afp from './afp.json';
import dcceew from './dcceew.json';
import employment from './employment.json';
import pmc from './pmc.json';
import ipAustralia from './ip-australia.json';
import geoscienceAustralia from './geoscience-australia.json';
import bom from './bom.json';

const salaryData = {
  agencies: {
    APS: aps,
    Defence: defence,
    ATO: ato,
    ABS: abs,
    ServicesAustralia: servicesAustralia,
    HomeAffairs: homeAffairs,
    DFAT: dfat,
    Treasury: treasury,
    Finance: finance,
    Health: health,
    Education: education,
    AGS: ags,
    Agriculture: agriculture,
    Infrastructure: infrastructure,
    Industry: industry,
    VeteransAffairs: veteransAffairs,
    AFP: afp,
    DCCEEW: dcceew,
    Employment: employment,
    PMC: pmc,
    IPAustralia: ipAustralia,
    GeoscienceAustralia: geoscienceAustralia,
    BOM: bom,
  }
};

export default salaryData;
